
import { AppBar } from "react-admin";
import { CustomUserMenu as UserMenu } from "./UserMenu";

export const CustomAppBar = props => <AppBar {...props} userMenu={<UserMenu />} />;